import React, { useCallback } from 'react';
import { Col, DatePicker, Descriptions, Form, Row, TimePicker } from 'antd';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';
import { FORMAT_DATE } from '../../../../constants/common';
import { TOUR_TRASH_TRANSLATION } from '../../../../constants/define/translation';
import { ValidTime } from '../../tour-trash/tab-pane/Details';
import { ButtonActionPage } from '../../../atoms/button/ButtonActionPage';

interface ScheduleDateTimePickerSectionProps {
  form: any;
  startTime: any;
  endTime: any;
  onChangeStartTime: (value: moment.Moment | null) => void;
  onChangeEndTime: (value: moment.Moment | null) => void;
  onHandleChangeDate: () => void;
  validTime: ValidTime;
}

export const ScheduleDateTimePickerSection = (props: ScheduleDateTimePickerSectionProps) => {
  const { t } = useTranslation(TOUR_TRASH_TRANSLATION);
  const { form, startTime, endTime, onChangeStartTime, onChangeEndTime, onHandleChangeDate, validTime } = props;

  const { validateStatus, help, isCheckStartDate } = validTime;

  const disabledStartDate = useCallback(
    date => {
      const now = moment().format(FORMAT_DATE);

      const isBeforeNow = moment(date).diff(now, 'second') < 0;

      return isBeforeNow;
    },
    [form],
  );

  const disabledEndDate = useCallback(
    date => {
      const startDateVal = form.getFieldValue('startDate');
      const now = moment().format(FORMAT_DATE);
      const isBeforeNow = moment(date).diff(now, 'second') < 0;
      const isBeforeStartDate =
        startDateVal && moment(date).diff(moment(startDateVal).format(FORMAT_DATE), 'second') < 0;

      return isBeforeNow || isBeforeStartDate;
    },
    [form],
  );

  return (
    <>
      <Descriptions title={t('tab.detail.form.time.title')} />
      <Row className="row-datetime-picker">
        <Col span={11}>
          <Form.Item
            name="startTime"
            validateStatus={isCheckStartDate ? validateStatus : undefined}
            help={isCheckStartDate ? help : undefined}
            initialValue={startTime}
            label={t('tab.detail.form.time.startTimePlaceholder')}
          >
            <TimePicker
              placeholder={t('tab.detail.form.time.startTimePlaceholder')}
              use12Hours
              format="hh:mm A"
              value={startTime}
              onChange={onChangeStartTime}
              showNow={false}
              minuteStep={15}
            />
          </Form.Item>
        </Col>
        <Col span={11} offset={2}>
          <Form.Item
            name="startDate"
            validateStatus={isCheckStartDate ? validateStatus : undefined}
            label={t('tab.detail.form.time.startDatePlaceholder')}
          >
            <DatePicker
              placeholder={t('tab.detail.form.time.startDatePlaceholder')}
              format="ll"
              disabledDate={disabledStartDate}
              onChange={onHandleChangeDate}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11}>
          <Form.Item
            name="endTime"
            label={t('tab.detail.form.time.endTimePlaceholder')}
            validateStatus={!isCheckStartDate ? validateStatus : undefined}
            help={!isCheckStartDate ? help : undefined}
            initialValue={endTime}
          >
            <TimePicker
              placeholder={t('tab.detail.form.time.endTimePlaceholder')}
              use12Hours
              format="hh:mm A"
              value={endTime}
              onChange={onChangeEndTime}
              showNow={false}
              minuteStep={15}
            />
          </Form.Item>
        </Col>
        <Col span={11} offset={2}>
          <Form.Item
            name="endDate"
            label={t('tab.detail.form.time.endDatePlaceholder')}
            validateStatus={!isCheckStartDate ? validateStatus : undefined}
          >
            <DatePicker
              placeholder={t('tab.detail.form.time.endDatePlaceholder')}
              format="ll"
              disabledDate={disabledEndDate}
              onChange={onHandleChangeDate}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row justify="end" style={{ position: 'absolute', bottom: 10, right: 10 }}>
        <ButtonActionPage
          disabled={form.getFieldValue('startDate') == null && form.getFieldValue('endDate') == null}
          text={t('form.btnSubmit')}
          id="1"
          className="btn-submit-generate-access-code mt-5"
          htmlType="submit"
        />
      </Row>
    </>
  );
};
